import styled from "styled-components";
import { Form as Unform } from "@unform/web";
import UnInput from "../../Components/Input";
import cover from "../../Assets/cover.png";

export const Container = styled.div`
  display: flex;
  max-width: 1800px;
  margin: 0 auto;
`;

export const Cover = styled.div`
  background: url(${cover});
  background-size: contain;
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100vh;
  border-right: 2px solid #eee;
  background-color: #f4f4f4;
  @media only screen and (max-width: 425px) {
    height: 0px;
    width: 0px;
  }
`;

export const Input = styled(UnInput)`
  width: 100%;
  border: 1px solid #ccc;
  transition-duration: 1s;
`;

export const Form = styled(Unform)`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;

  & > * {
    width: 80%;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  & a {
    text-align: center;
    text-decoration: underline;
  }
  & button {
    background: #2dad67;
    border-radius: 50px;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 1px;
    color: white;
    transition-duration: 1s;
  }
  & button:hover {
    background: #1f6d42;
  }
`;

export const Title = styled.h1`
  color: #373737;
  font-weight: bold;
  text-align: center;
  margin-bottom: 50px;
`;

export const Brand = styled.div`
  text-align: center;
  & > img {
    width: auto;
    max-height: 50px;
  }
  @media (min-width: 426px) {
    margin-bottom: 80px;
    & > img {
      width: auto;
      max-height: 50px;
    }
  }
`;

export const ChangePasswordContainer = styled.div`
  & > * {
    margin-bottom: 20px;
  }
`;

export const New = styled.div`
  margin-top: 30px;
  font-size: 12px;
`;
